import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { CobrancaVale } from '../domain/cobranca-vale.model';

export class CobrancaValeSerializer extends DomainSerializer<CobrancaVale> {}
